export const LOCAL_STORAGE_KEYS = {
  JWT_TOKEN: "access-token",
  USER_DATA: "user-info",
};

export const DEFAULT_ROWS_PER_PAGE_FOR_TABLE = 20;

const SWAGUP_DASHBOARD_STAGING_URL = "https://dashboard.staging.swagup.com";
const SWAGUP_DASHBOARD_PROD_URL = "https://app.swagup.com";

export const getSwagUpDashboardBaseUrl = () => {
  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";
  const isNonProd =
    hostname.includes("staging") ||
    hostname.includes("stg") ||
    hostname === "localhost" ||
    hostname === "127.0.0.1";
  return isNonProd ? SWAGUP_DASHBOARD_STAGING_URL : SWAGUP_DASHBOARD_PROD_URL;
};

export const buildSwagUpCatalogUrl = (
  productName?: string,
  productCode?: string,
) => {
  if (!productName || !productCode) return "";
  return `${getSwagUpDashboardBaseUrl()}/dashboard/catalog/product/${encodeURIComponent(
    productName,
  )}/${encodeURIComponent(productCode)}`;
};
